import script from "./UltimateEleven.vue?vue&type=script&setup=true&lang=js"
export * from "./UltimateEleven.vue?vue&type=script&setup=true&lang=js"

import "./UltimateEleven.vue?vue&type=style&index=0&id=59224961&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59224961"]])

export default __exports__